import functions from '../functions';

$(() => {
    inquiry.init();
});

const inquiry = {
    init() {
        let now = functions.cleanDate(new Date);
        let $datesI = null;
        $('.datepicker-range-inquiry').each((i, elem) => {
            const $datepicker = $(elem);
            const minDate = $datepicker.attr('data-min');
            const maxDate = $datepicker.attr('data-max');
            const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
            const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
            const duration = Number($datepicker.attr('data-duration'));
            const position = $datepicker.attr('data-position') || 'auto';
            const minStayText = $datepicker.attr('data-minstay');
            $datesI = $datepicker.flatpickr({
                mode: "range",
                showMonths: functions.isMobile() ? 1 : 2,
                altInput: true,
                wrap: true,
                altFormat: "j.m.Y",
                dateFormat: "Y-m-d",
                defaultDate: defaultDate,
                minDate: minDate && minDate >= now ? minDate : now,
                maxDate: maxDate ? maxDate : null,
                disableMobile: true,
                prevArrow: '<i class="fa-light fa-arrow-left fa-fw pr-2"></i>',
                nextArrow: '<i class="fa-light fa-arrow-right fa-fw pl-2"></i>',
                locale: {
                    rangeSeparator: ' - '
                },
                position: position,
                minStayText: minStayText ? minStayText : '',
                onDayCreate(dObj, dStr, fp, dayElem) {

                    let minStay = 1;
                    let to = new Date(maxDate);
                    let weekday = new Date(dayElem.dateObj).getDay();
                    weekday = '' + (weekday ? weekday : 7);
                    to.setHours(0, 0, 0, 0);
                    let onlyCheckInSelected = fp.selectedDates[0] && !fp.selectedDates[1];
                    // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                    let from = dayElem.dateObj;
                    let too = fp.selectedDates[0];
                    // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
                    // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());

                    let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

                    if (onlyCheckInSelected) {
                        if (Math.abs(diff) < minStay) {
                            dayElem.className += ' flatpickr-disabled ';
                            if (diff) {
                                if (minStayText) {
                                    $(dayElem).tooltip({
                                        title: minStayText.replace('{$min_stay}', minStay) || ''
                                    });
                                }
                            }
                        }
                    }

                    if (dayElem.dateObj > to || (arrival.length && $.inArray(weekday, arrival) == -1)) {
                        dayElem.classList.add('unselectable');
                    }
                },
            });
            // to style clear toggler
            $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
        });

        $('form#inquiry').on('submit', e => {
            e.preventDefault();

            $('.modal.request-form').css('z-index', 1000);
            $('#inquiryResponseModal').modal('show');

            //$('.contact-btn').addClass('d-none');
            //$('.contact-spinner').removeClass('d-none');
            //$('.contact-spinner').addClass('d-flex');

            let params = {};
            let allParams = $(e.currentTarget).serializeArray();
            $.each(allParams, function (i, field) {
                params[field.name] = field.value;
            });

            // datesi
            //params['dates'] = '';

            if (! params.dates) {
                $datesI.open();
                //$('.contact-btn').removeClass('d-none');
                //$('.contact-spinner').addClass('d-none');
                //$('.contact-spinner').removeClass('d-flex');
                return;
            }

            functions.setFormData($('form#inquiry'), params);
            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            params['recaptchaType'] = 'enterprise';

            grecaptcha.enterprise.ready(function () {
                grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        response.status ? $('.inquiry-success').removeClass('d-none') : $('.inquiry-error').removeClass('d-none');

                        /*$('.request-form').on('hide.bs.modal', e => {
                            $('.request-error, .request-success').addClass('d-none');
                        });*/

                        if (response.status == true) {
                            $('form#inquiry')[0].reset();
                        }

                        //$(".inquiry-response").html(response.data);
                        $('#inquiryResponseModal').addClass('inquiry-response');
                        $('.inquiry-loading').addClass('d-none');

                        if (response.status == true) {
                            $('.inquiry-success').removeClass('d-none');
                            $('.modal.request-form').modal('hide');
                            $('.modal.request-form').css('z-index', 1055);

                            const redirectUrl = $('[data-inquiryredirect]').attr('data-inquiryredirect');
                            redirectUrl && (location.href = redirectUrl);
                        } else {
                            $('.inquiry-error').removeClass('d-none');
                        }
                        
                    });
                });
            });
        });

        $('#inquiryResponseModal').on('hidden.bs.modal', e => {
            $('#inquiryResponseModal').removeClass('inquiry-response');
            $('.inquiry-loading').removeClass('d-none');
            $('.inquiry-success').addClass('d-none');
            $('.inquiry-error').addClass('d-none');
        });
    }
}